export default __webpack_public_path__ + "static/media/subscribe-banner-mobile.425d29a1.png";